import { ConversationClassification, ConversationStatus } from "../models/conversation.models";
import { TimelineViewMode } from "../models/timeline.models";

/**
 * Options for the conversation-detail timeline "View" dropdown.
 * `divider` renders a separator above the item (matches the design: Simple Timeline sits below a rule).
 */
export const TIMELINE_VIEW_OPTIONS: {
  mode: TimelineViewMode;
  labelKey: string;
  descriptionKey?: string;
  divider?: boolean;
}[] = [
    {
        mode: TimelineViewMode.FULL,
        labelKey: 'smart_inbox.inbox_view.detail.view_full_timeline',
    },
    {
        mode: TimelineViewMode.EMAILS,
        labelKey: 'smart_inbox.inbox_view.detail.view_emails_only',
    },
    {
        mode: TimelineViewMode.COMMENTS,
        labelKey: 'smart_inbox.inbox_view.detail.view_comments_only',
    },
    {
        mode: TimelineViewMode.SIMPLE,
        labelKey: 'smart_inbox.inbox_view.detail.view_simple_timeline',
        descriptionKey: 'smart_inbox.inbox_view.detail.view_simple_timeline_description',
        divider: true,
    },
];

export const CONVERSATION_CATEGORIES = [
    {
        name: 'Inquiry',
        type: ConversationClassification.INQUIRY,
    },
    {
        name: 'RFQ',
        type: ConversationClassification.RFQ,
    },
    {
        name: 'Order',
        type: ConversationClassification.ORDER,
    },
    {
        name: 'Support',
        type: ConversationClassification.SUPPORT,
    },
    {
        name: 'Admin',
        type: ConversationClassification.ADMIN,
    },
    {
        name: 'Undefined',
        type: ConversationClassification.UNDEFINED,
    },
];

export const CONVERSATION_STATUSES = [
    {
        icon: 'new',
        name: 'New',
        type: ConversationStatus.NEW,
    },
    {
        icon: 'open',
        name: 'Open',
        type: ConversationStatus.OPEN,
    },
    {
        icon: 'on_hold',
        name: 'On Hold',
        type: ConversationStatus.ON_HOLD,
    },
    {
        icon: 'closed',
        name: 'Closed',
        type: ConversationStatus.CLOSED,
    },
];
